module.exports = __webpack_public_path__ + "static/features-slide5-0822e2aa2a71c6e4f32d40c9ba6e4290.png";